export const patientHistoryJobStatuses = [
  'queued',
  'scheduled',
  'in_progress',
  'done',
  'error',
] as const;
export type PatientHistoryJobStatus = (typeof patientHistoryJobStatuses)[number];

export const patientHistoryJobProviderStatuses = [
  'initialize',
  'in_progress',
  'done',
  'done_with_info',
  'error',
  'unset',
  'skipped',
] as const;
export type PatientHistoryJobProviderStatus = (typeof patientHistoryJobProviderStatuses)[number];

export type PatientHistoryJobProvider = {
  service: string;
  status: PatientHistoryJobProviderStatus;
};

export type PatientHistoryJobResponseJobData = {
  type: string;
  id: string;
  attributes: {
    jobStatus: PatientHistoryJobStatus;
    practitioner: {
      npi: string;
      name: string;
      role: string;
    };
    providers: Array<PatientHistoryJobProvider>;
    targetDate?: string;
    createdAt: number;
    lastUpdatedAt: number;
  };
  relationships: {
    patient: {
      data: { type: 'fhir/Patient'; id: string };
    };
    practitioner?: {
      data: { type: 'fhir/Practitioner'; id: string };
    };
  };
};

export type PatientHistoryJobResponse = {
  data: Array<PatientHistoryJobResponseJobData>;
  links: { self: string; prev?: string; next?: string };
};

export function generateDemoPatientHistoryJob(patientId: string): PatientHistoryJobResponseJobData {
  const now = new Date();

  return {
    type: 'patient-history/jobs',
    id: 'demo',
    attributes: {
      jobStatus: 'done',
      providers: [
        {
          service: 'commonwell',
          status: 'done',
        },
        {
          service: 'carequality',
          status: 'done',
        },
        {
          service: 'tefca',
          status: 'in_progress',
        },
        {
          service: 'surescripts',
          status: 'done',
        },
      ],
      practitioner: {
        npi: '000000000',
        name: 'Demo Practitioner',
        role: 'Demo Role',
      },
      createdAt: now.getTime() / 1000 - 60 * 60 * 24 * 21, // 21 days ago
      lastUpdatedAt: now.getTime() / 1000 - 60 * 60 * 24 * 3, // 3 days ago
      targetDate: now.toISOString(),
    },
    relationships: {
      patient: {
        data: {
          type: 'fhir/Patient',
          id: patientId,
        },
      },
    },
  };
}
